module.exports = __webpack_public_path__ + "static/media/logo.f2775a03.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/logo.svg
// module id = 1891
// module chunks = 24 25 26